import React, { useState } from 'react';
import { Upload } from 'antd';
import apis from '@/apis';
import { beforePicUpload, getRules, Data } from '../../utils';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';

interface Props {
  onChange?: (e: string) => void;
  value?: string;
  data: Data;
}

const Uploader = (props: Props) => {
  const { value = '', onChange = () => {}, data } = props;
  const [loading, setLoading] = useState(false);

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>上传</div>
    </div>
  );

  const customRequest = ({ file, filename, onError, onSuccess }: any) => {
    const formData = new FormData();
    formData.append('file', file);
    apis
      .uploadPic(formData)
      .then((res) => {
        const { ret } = res;
        if (ret === '0' && res.data) {
          onSuccess(
            {
              name: filename,
              status: 'done',
              thumbUrl: res.data.urlList[0],
              url: res.data.urlList[0],
            },
            file
          );
        } else {
          onError();
        }
      })
      .catch(onError);

    return {
      abort() {
        console.log('upload progress is aborted.');
      },
    };
  };

  const getUrl = (info: any) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      setLoading(false);
      onChange(info.file.response.url);
    }
  };

  return (
    <>
      <Upload
        name="avatar"
        listType="picture-card"
        className="avatar-uploader"
        showUploadList={false}
        customRequest={customRequest}
        onChange={getUrl}
        accept="image/*"
        // @ts-ignore
        beforeUpload={(file) =>
          beforePicUpload(file, {
            imgWidth: getRules('imgWidth', data),
            imgHeight: getRules('imgHeight', data),
            imgExtension: getRules('imgExtension', data),
            imgSize: getRules('imgSize', data),
          })
        }
      >
        {value ? <img src={value} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
      </Upload>
      <div className="form-img-rules">{`【尺寸要求】尺寸${getRules('imgWidth', data)}*${getRules(
        'imgHeight',
        data
      )}px；大小${getRules('imgSize', data)}kb以内；支持扩展名${getRules('imgExtension', data)}`}</div>
    </>
  );
};

export default Uploader;
